import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { filter, firstValueFrom } from 'rxjs';
import { LayersService } from 'src/app/services/layers.service';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-favorite-layer',
  imports: [],
  templateUrl: './favorite-layer.component.html',
  styleUrl: './favorite-layer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FavoriteLayerComponent implements OnInit {
  constructor(
    private readonly modulesFacade: ModulesFacade,
    private readonly userDataService: UserDataService,
    private readonly layersService: LayersService,
  ) {}

  async ngOnInit(): Promise<void> {
    await firstValueFrom(this.userDataService.loaded$.pipe(filter(loaded => !!loaded)));

    const modules = await firstValueFrom(this.modulesFacade.modules$.pipe(filter(modules => modules.length > 0)));
    const favoriteStations = modules.filter(module => module.mode === 'favorite' && module.type === 'NAMain');

    this.layersService.setGeoJSONData('favorite-stations', favoriteStations, modules);
  }
}
